import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextareaAutosize, Button } from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';
import clsx from 'clsx';

import { closeModal } from 'features/utilsSlice';
import { postRequest } from 'utils/api';
import { getGigOwner } from 'utils/helpers';
import useModalOpen from 'hooks/useModalOpen';
import TransitionDialog from 'components/TransitionDialog';
import FeedbackEmptyIcon from 'public/icons/feedback-empty.svg';
import FeedbackStarIcon from 'public/icons/feedback-star.svg';
import styles from 'styles/components/gigs/InfluencerFeedback.module.scss';

const DialogContent = ({ handleClose, handleSuccess }) => {
  const [comment, setComment] = useState('');
  const [rating, setRating] = useState(0);
  const currentUser = useSelector(state => state.auth.currentUser);
  const gig = useSelector(state => state.utils.modalData['Feedback']?.gig);
  const gigOwner = getGigOwner(currentUser, gig.user_id);

  const getReviewTitle = rating => {
    switch (rating) {
      case 1:
        return 'EVERYTHING WAS BAD';
      case 2:
        return 'EVERYTHING WAS FAIR';
      case 3:
        return 'EVERYTHING WAS GOOD';
      case 4:
        return 'EVERYTHING WAS VERY GOOD';
      case 5:
        return 'EVERYTHING WAS GREAT!';
      default:
        return '';
    }
  };

  const handleSubmit = () => {
    postRequest({
      endpoint: 'reviews',
      data: { review: { comment, gig_id: gig.id, rating } },
      successMessage: 'Successfully submitted feedback',
    })
      .then(() => {
        handleSuccess();
        handleClose();
      })
      .catch(() => {});
  };

  return (
    <div className={styles.feedbackContainer}>
      <div className={clsx(styles.header, 'border-bottom')}>
        <h3>Rate the gig</h3>
      </div>

      <div className={clsx(styles.rating, 'border-bottom')}>
        <h2>
          {gigOwner
            ? `How was your delivery from ${gig.profile.display_name}?`
            : `How was the gig from ${gig.user.display_name}?`}
        </h2>

        <Rating
          name={`${gig.id}-rating`}
          precision={1}
          icon={<FeedbackStarIcon />}
          emptyIcon={<FeedbackEmptyIcon />}
          value={rating}
          onChange={(_event, newValue) => setRating(newValue === null ? 0 : newValue)}
        />

        <h4>{getReviewTitle(rating)}</h4>
      </div>

      {rating > 0 && (
        <>
          <div className={styles.feedback}>
            <h3>What went well?</h3>

            <TextareaAutosize
              minRows={5}
              maxRows={5}
              placeholder="Tap to add additional feedback"
              onChange={e => setComment(e.target.value)}
              maxLength={255}
              autoFocus
            />
          </div>

          <Button onClick={handleSubmit} variant="contained" color="primary">
            Submit
          </Button>
        </>
      )}
    </div>
  );
};

const FeedbackDialog = props => {
  const dispatch = useDispatch();
  const open = useModalOpen('Feedback');

  const handleClose = () => {
    dispatch(closeModal('Feedback'));
  };

  return (
    <TransitionDialog open={open} handleClose={handleClose} styles={styles}>
      <DialogContent handleClose={handleClose} {...props} />
    </TransitionDialog>
  );
};

export default FeedbackDialog;
